import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daimchboh653ivfvogag";

type Status = "idle" | "submitting" | "success" | "error";

export default function SubscribeSection() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honey = String(data.get("company_alt") ?? "").trim();
    if (honey) {
      setStatus("success");
      form.reset();
      return;
    }

    setStatus("submitting");
    setFormError("");

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === "company_alt") return;
      payload.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const okCode = parsed?.code === "OK";

      if (!response.ok || !okCode || /spam/i.test(serverMsg)) {
        setStatus("error");
        setFormError(serverMsg && !/spam/i.test(serverMsg) ? serverMsg : "提交没有成功,请稍后再试一次。");
        return;
      }

      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络有点问题,请检查连接后再试一次。");
    }
  }

  return (
    <section className="px-4 md:px-10 pb-16 md:pb-24">
      <div className="relative overflow-hidden rounded-lg bg-primary-950 px-6 md:px-14 py-12 md:py-16">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-10 w-72 h-72 rounded-full bg-accent-500/20 blur-3xl"></div>

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-background-50/15 text-background-50 mb-4">
              <i className="ri-mail-line text-accent-300"></i>
              每日一封,只看最有讨论度的
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">订阅热门话题日报</h2>
            <p className="text-sm md:text-base text-background-100/90 mt-3 leading-relaxed">
              我们会把每天讨论度最高的几个话题整理成一封短邮件,不刷屏、不带广告,想看的时候点开就行。
            </p>
          </div>

          <form id="daily-digest-form" data-readdy-form onSubmit={handleSubmit} className="w-full" noValidate>
            <div className="flex flex-col sm:flex-row gap-3">
              <label className="flex-1">
                <span className="sr-only">邮箱地址</span>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="your@email.com"
                  className="w-full px-4 py-3 rounded-md bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
                />
              </label>
              <button
                type="submit"
                disabled={status === "submitting"}
                className="px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {status === "submitting" ? <><i className="ri-loader-4-line animate-spin"></i>提交中</> : <><i className="ri-send-plane-fill"></i>立即订阅</>}
              </button>
            </div>

            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="form-honey-field"
            />

            {status === "success" && (
              <p className="text-sm text-accent-300 mt-3 flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line"></i>
                订阅成功,之后的热门话题日报会发送到这个邮箱。
              </p>
            )}
            {status === "error" && (
              <p className="text-sm text-primary-200 mt-3 flex items-center gap-1.5">
                <i className="ri-error-warning-line"></i>
                {formError}
              </p>
            )}
            <p className="text-xs text-background-100/60 mt-3">我们只用于发送话题日报,随时可以退订。</p>
          </form>
        </div>
      </div>
    </section>
  );
}